// query the dom for block that is focused on. Used by state.focusedBlockElement to position floating toolbar
export default function getBlockFromDom(key) {
  return document.querySelector(`*[data-offset-key='${key}-0-0']`);
}
